// src/pages/POsSandbox.jsx
import React from "react";
import POs from "./POs";

export default function POsSandbox() {
  return <POs sandbox />;
}

